/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI Document on Azure Functions
 * This is the OpenAPI Document on Azure Functions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  FileContentResult,
} from '../models/index';
import {
    FileContentResultFromJSON,
    FileContentResultToJSON,
} from '../models/index';

/**
 * 
 */
export class TemplateApi extends runtime.BaseAPI {

    /**
     */
    async runRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FileContentResult>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/GetProductTemplate`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FileContentResultFromJSON(jsonValue));
    }

    /**
     */
    async run(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FileContentResult> {
        const response = await this.runRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async run_1Raw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FileContentResult>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/GetSupplierTemplate`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FileContentResultFromJSON(jsonValue));
    }

    /**
     */
    async run_1(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FileContentResult> {
        const response = await this.run_1Raw(initOverrides);
        return await response.value();
    }

}
